import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import { onGoBack } from '../../common/globals';
import withLoader from '../../common/withLoader';
import withNotify from '../../common/withNotify';
import withGoBack from '../../common/withGoBack';
import withScanInventory from '../../common/withScanInventory';
import { getInventoryBySessionID, getInventoryProductsByAccountName } from '../../utils/db';

class ScanViewInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryScan: {},
      congin: 0,
      par: 0
    };
  }

  _goBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackScanSession = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetInventory = async (groupedData) => {
    try {
      let inventoryScan = {};
      Object.keys(groupedData).map(async (data) => {
        let par = 0; let congin = 0; let
          scan = 0;
        groupedData[data].map((item) => {
          if (item.InventoryType === 'PAR') {
            par += 1;
          } else if (item.InventoryType === 'CONSIGN') {
            congin += 1;
          } else if (item.InventoryType === 'SCAN' || item.InventoryType === 'MANUAL' || item.InventoryType === 'EXTDEVICE') {
            scan += item.Qty;
          }
        });
        inventoryScan = Object.assign(
          inventoryScan,
          {
            [data]: {
              PAR: par,
              CONSIGN: congin,
              SCAN: scan,
              AccountName: data,
              data: groupedData[data]
            }
          }
        );
      });
      const finalObj = {};
      const inventoryPromiseAll = Object.keys(inventoryScan).map(async (data) => {
        inventoryScan[data].data.map((value) => new Promise((resolve) => {
          resolve(true);
          if (finalObj[value.AccountName]) {
            const booleanValue = finalObj[value.AccountName]
              .ProductNo.filter((item) => item.ProductNo === value.ProductNo).length > 0;
            if (booleanValue) {
              finalObj[value.AccountName].ProductNo.map((item) => {
                if (item.ProductNo === value.ProductNo) {
                  item.LotNo.push({
                    SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE') ? Number(value.Qty) : 0,
                    PAR: value.InventoryType === 'PAR' ? Number(value.Qty) : 0,
                    CONSIGN: value.InventoryType === 'CONSIGN' ? Number(value.Qty) : 0,
                    ExpireDate: value.ExpireDate,
                    LotNo: value.LotNo,
                    ProductNo: value.ProductNo,
                    InventoryType: value.InventoryType,
                    ID: value.ID
                  });
                }
              });
            } else {
              finalObj[value.AccountName].ProductNo.push({
                AccountAbb: value.AccountAbb,
                AccountNo: value.AccountNo,
                InventoryType: value.InventoryType,
                OfficeName: value.OfficeName,
                TeamName: value.TeamName,
                UpdateDate: value.UpdateDate,
                LotNo: [{
                  SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE') ? Number(value.Qty) : 0,
                  PAR: value.InventoryType === 'PAR' ? Number(value.Qty) : 0,
                  CONSIGN: value.InventoryType === 'CONSIGN' ? Number(value.Qty) : 0,
                  ExpireDate: value.ExpireDate,
                  LotNo: value.LotNo,
                  ProductNo: value.ProductNo,
                  InventoryType: value.InventoryType,
                  ID: value.ID
                }],
                AccountName: value.AccountName,
                ProductNo: value.ProductNo,
                ProductDescription: value.ProductDescription,
                ID: value.ID
              });
            }
          } else {
            const {
              InventoryType,
              OfficeName,
              ProductDescription,
              ProductNo,
              Qty,
              TeamName,
              LotNo,
              AccountName,
              ID,
              SCAN,
              UpdateDate, ExpireDate, ...rest
            } = value;
            finalObj[value.AccountName] = {
              ...rest,
              PAR: inventoryScan[data].PAR,
              CONSIGN: inventoryScan[data].CONSIGN,
              SCAN: inventoryScan[data].SCAN,
            };
            finalObj[value.AccountName].ProductNo
                = [{
                InventoryType,
                OfficeName,
                ProductDescription,
                ProductNo,
                Qty,
                TeamName,
                UpdateDate,
                AccountName,
                ID,
                LotNo: [{
                  SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE') ? Number(Qty) : 0,
                  PAR: value.InventoryType === 'PAR' ? Number(Qty) : 0,
                  CONSIGN: value.InventoryType === 'CONSIGN' ? Number(Qty) : 0,
                  ExpireDate,
                  LotNo,
                  ProductNo,
                  InventoryType,
                  ID
                }],
                ExpireDate
              }];
          }
        }));
      });
      await Promise.all(inventoryPromiseAll);
      const inventoryScanPromiseAll = Object.keys(finalObj).map(async (data) => {
        finalObj[data].ProductNo.map((value) => new Promise((resolve) => {
          const lotData = [];
          resolve(true);
          value.LotNo.map((lot) => {
            const booleanValue = lotData.filter((item) => item.LotNo === lot.LotNo).length > 0;
            if (booleanValue) {
              lotData.map((item) => {
                if (item.LotNo === lot.LotNo) {
                  item.SCAN += lot.SCAN;
                  item.PAR += lot.PAR;
                  item.CONSIGN += lot.CONSIGN;
                }
              });
            } else {
              lotData.push({
                SCAN: (lot.InventoryType === 'SCAN' || lot.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE') ? lot.SCAN : 0,
                PAR: lot.InventoryType === 'PAR' ? lot.PAR : 0,
                CONSIGN: lot.InventoryType === 'CONSIGN' ? lot.CONSIGN : 0,
                ExpireDate: lot.ExpireDate,
                LotNo: lot.LotNo,
                ProductNo: lot.ProductNo,
                InventoryType: lot.InventoryType,
                ID: lot.ID
              });
            }
          });
          value.LotNo = lotData;
        }));
      });
      await Promise.all(inventoryScanPromiseAll);
      this.setState({
        inventoryScan: finalObj
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    const { scanInventory, setLoader } = this.props;
    setLoader(true);
    const getInventoryProducts = await getInventoryProductsByAccountName(
      scanInventory.AccountName
    );
    let par = 0; let congin = 0;
    getInventoryProducts.map((item) => {
      if (item.InventoryType === 'PAR') {
        par += 1;
      } else if (item.InventoryType === 'CONSIGN') {
        congin += 1;
      }
    });
    this.setState({
      congin,
      par
    });
    const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
    inventoryRes.map((value) => {
      value.ExpireDate = moment(value.ExpireDate).format('MM/DD/YYYY');
      value.InventoryType = value.ProductEnterType;
    });
    // const getSessionIdData = getInventoryProducts.concat(inventoryRes);
    const inventoryScan = _.groupBy(inventoryRes, 'AccountName');
    await this._onGetInventory(inventoryScan);
    setLoader(false);
  }

  render() {
    const { inventoryScan, congin, par } = this.state;
    return (
      <section className="list-section resizer-class">
        <Header
          title="View Inventory"
          goBack={this._goBack}
        />
        <section className="scan-view-inventory-section">
          {
            Object.keys(inventoryScan).length > 0 ? Object.keys(inventoryScan)
              .map((value, index) => (
                <>
                  <div className="single-session-view">
                    <div className="view-inv-tp" key={index}>
                      <div className="container">
                        <div className="row">
                          <div className="col-8 view-int-product-row">
                            <p>{value}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="view-inv-tp">
                      <div className="container">
                        <div className="row">
                          <div className="col-8">
                            <p />
                          </div>
                          <div className="col-4 align-self-end">
                            <div className="right-side">
                              <div className="row gx-2">
                                <div className="col-4">
                                  <p>P</p>
                                </div>
                                <div className="col-4">
                                  <p>C</p>
                                </div>
                                <div className="col-4">
                                  <p>S</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="view-inv-tp">
                      <div className="container">
                        <div className="row">
                          <div className="col-8">
                            <p style={{ float: 'right' }}>Total Products</p>
                          </div>
                          <div className="col-4 total-product">
                            <div className="right-side">
                              <div className="row gx-2">
                                <div className="col-4">
                                  <p style={{ borderRight: '1px solid' }}>{par}</p>
                                </div>
                                <div className="col-4">
                                  <p style={{ borderRight: '1px solid' }}>{congin}</p>
                                </div>
                                <div className="col-4">
                                  <p>{inventoryScan[value].SCAN}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="view-inv-pro-group">
                    {
                      inventoryScan[value].ProductNo.map((item, idx) => (
                        <>
                          {
                              (item.InventoryType === 'SCAN' || item.InventoryType === 'MANUAL' || item.InventoryType === 'EXTDEVICE')
                              && (
                              <div
                                className="container view-inventory-row" key={idx}
                                style={{ position: 'relative' }}
                              >
                                <a
                                  className="btn-down view-int-lot-info-row collapsed" data-bs-toggle="collapse"
                                  href={`#viewInvDetails${item.ProductNo}`}
                                  role="button" aria-expanded="false"
                                  aria-controls={`viewInvDetails${item.ProductNo}`}
                                >&nbsp;
                                </a>
                                <div className="row">
                                  <div className="col-8 view-int-product-row">
                                    <p>{item.ProductNo}
                                      <a
                                        className="btn-down collapsed" data-bs-toggle="collapse"
                                        href={`#viewInvDetails${item.ProductNo}`}
                                        role="button" aria-expanded="false"
                                        aria-controls={`viewInvDetails${item.ProductNo}`}
                                      >
                                        <i className="icon-right fas fa-chevron-down" style={{ color: '#eda340' }} />
                                      </a>
                                    </p>
                                    <p className="mt-0">{item.ProductDescription}</p>
                                  </div>
                                  <div className="col-4">
                                    <div className="right-side">
                                      <div className="row gx-2">
                                        <div className="col-4">
                                          <p>{item.LotNo.reduce((sum, { PAR }) => sum + PAR, 0)}
                                          </p>
                                        </div>
                                        <div className="col-4">
                                          <p>{item.LotNo.reduce((
                                            sum, { CONSIGN }
                                          ) => sum + CONSIGN, 0)}
                                          </p>
                                        </div>
                                        <div className="col-4">
                                          <p>{item.LotNo.reduce((sum, { SCAN }) => sum + SCAN, 0)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              )
                          }
                          <div className="collapse view-inv-details" id={`viewInvDetails${item.ProductNo}`}>
                            {
                              item.LotNo.map((lotNo) => (
                                // (lotNo.LotNo !== null && lotNo.ExpireDate !== 'Invalid date')
                                // && (
                                <div className="container pt-0">
                                  <div className="col-8">
                                    <div className="left-side">
                                      <div className="row gx-2">
                                        <div className="col-7">
                                          <span>Lot #</span>
                                        </div>
                                        <div className="col-5 ps-0">
                                          <span>Exp Date</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {
                                item.LotNo.map((lot, key) => (
                                  <div className="row" key={key}>
                                    <div className="col-8">
                                      <div className="left-side">
                                        <div className="row gx-2">
                                          <div className="col-7">
                                            <p>{lot.LotNo}</p>
                                          </div>
                                          <div className="col-5">
                                            <p>{lotNo.ExpireDate !== 'Invalid date' ? lot.ExpireDate : ''}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <div className="right-side">
                                        <div className="row gx-2">
                                          <div className="col-4">
                                            <p>{lot.PAR}</p>
                                          </div>
                                          <div className="col-4">
                                            <p>{lot.CONSIGN}</p>
                                          </div>
                                          <div className="col-4">
                                            <p>{lot.SCAN}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                                    }
                                </div>
                                // )
                              ))
                            }
                          </div>
                        </>
                      ))
                        }
                  </div>
                </>
              )) : <p className="no-data-available">No data available</p>
          }

        </section>

      </section>
    );
  }
}

export default withScanInventory(withLoader(withNotify(withGoBack(ScanViewInventory))));
